module.exports = __webpack_public_path__ + "static/media/COA_CAD_logo.b8022167.png";